import { ReactNode } from 'react';
import styled from 'styled-components';

import { cFFFFFF } from '#/colors';

interface Props {
  children: ReactNode;
}

export default function Title(props: Props) {
  const { children } = props;

  return <Container>{children}</Container>;
}

const Container = styled.div`
  font-weight: 700;
  line-height: 12px;
  color: ${cFFFFFF};
  margin-bottom: 5px;
`;
